import { gql } from '@apollo/client';

export default gql`
  fragment UserSettingsFields on UserSettings {
    allowAccountAccess
    uiTheme
    notifications {
      direct {
        email
        slack
      }
      participant {
        email
        slack
      }
      team {
        email
        slack
      }
    }
  }
`;
